module.exports = __webpack_public_path__ + "static/media/cxa-fa-uptv.4fe7539c.gif";